import { useEffect } from "react";

// Force un fond transparent sur <html>/<body> — nécessaire car le thème
// MUI de l'app (CssBaseline ou index.css) impose vraisemblablement un
// fond opaque par défaut, qui écraserait sinon le style transparent voulu
// pour ces pages "overlay OBS". Restaure la valeur précédente au
// démontage, pour ne pas laisser le body transparent si l'utilisateur
// navigue ailleurs dans le SPA sans recharger complètement la page.
export function useTransparentBody() {
    useEffect(() => {
        const prevHtml = document.documentElement.style.background;
        const prevBody = document.body.style.background;
        document.documentElement.style.background = "transparent";
        document.body.style.background = "transparent";
        return () => {
            document.documentElement.style.background = prevHtml;
            document.body.style.background = prevBody;
        };
    }, []);
}
